import styled from "@emotion/styled";
export const StyledSectionTitleContainer = styled.div`
  font-weight: 300;
  font-size: 1.125rem;
  height: 40px;
  display: flex;
  align-items: center;
  border-left: 1px solid black;
  padding-left: 16px;
`;
